import { Component, OnInit } from '@angular/core';
import { FormField } from '../../../dto/util/form-field';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '../../../constants/constants';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { EmpresaService } from '../services/empresa.service';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-credenciales-datos-adicionales-empresa',
  templateUrl: './credenciales-datos-adicionales-empresa.component.html',
  styleUrl: './credenciales-datos-adicionales-empresa.component.scss'
})
export class CredencialesDatosAdicionalesEmpresaComponent implements OnInit {

  // Multilenguaje
  comunText: any = {};
  alertaText: any = {};
  empresaText: any = {};

  // Pasos
  pasoActual: number = 1;

  // Formularios
  formFieldsPaso1: FormField[] = [];
  formFieldsPaso2: FormField[] = [];

  formPaso1!: FormGroup;
  formPaso2!: FormGroup;

  isEqualsPassword: boolean = false;

  token: string = '';
  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
    private readonly alertaModalService: AlertaModalService,
    private readonly empresaService: EmpresaService,
    private route: ActivatedRoute,
    private readonly router: Router
  ) { }

  ngOnInit(): void {

    // Cargar multilenguaje antes de construir formularios
    this.translate.stream([
      'tramites',
      'comun-label',
      'alertas',
      'crear-empresa'
    ]).subscribe(() => {

      this.comunText = this.translate.instant('comun-label');
      this.alertaText = this.translate.instant('alertas');
      this.empresaText = this.translate.instant('crear-empresa');

      this.buildForms();
    });

    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
    });
  }

  buildForms() {
    // CREAR CONTRASEÑA
    this.formFieldsPaso1 = [
      // {
      //   name: 'userName',
      //   label: this.empresaText['username'],
      //   type: 'text',
      //   required: true,
      //   width: '6',
      //   validation: [
      //     Validators.required,
      //     Validators.minLength(4),
      //     Validators.maxLength(50),
      //     Validators.pattern(Constants.REGEX_USERNAME)
      //   ],
      //   errorMessages: {
      //     required: this.empresaText['required-username'],
      //     minlength: this.empresaText['minlength-username'],
      //     maxlength: this.empresaText['maxlength-username'],
      //     pattern: this.empresaText['pattern-username'],
      //   }
      // },
      {
        name: 'password',
        label: this.empresaText['password'],
        type: 'password',
        required: true,
        width: '6',
        validation: [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(Constants.REGEX_PASSWORD_STRONG)
        ],
        errorMessages: {
          required: this.empresaText['password-required'],
          minlength: this.empresaText['password-minlength'],
          pattern: this.empresaText['password-pattern']
        }
      },
      {
        name: 'repeatPassword',
        label: this.empresaText['repeatPassword'],
        type: 'password',
        required: true,
        width: '6',
        validation: [
          Validators.required
        ],
        errorMessages: {
          required: this.empresaText['repeatPassword-required']
        }
      }
    ];

    this.formPaso1 = this.fb.group({
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(Constants.REGEX_PASSWORD_STRONG)
      ]],
      repeatPassword: ['', Validators.required]
    });

    // DATOS OBSERVATORIO
    this.formFieldsPaso2 = [
      {
        name: 'tamanoEmpresa',
        label: this.empresaText['tamanoEmpresa'],
        type: 'text',
        required: true,
        width: '6',
        disabled: true,
      },
      {
        name: 'empleados',
        label: this.empresaText['empleados'],
        type: 'number',
        required: true,
        width: '6',
        disabled: true,
      },
      {
        name: 'ciiu',
        label: this.empresaText['ciiu'],
        type: 'text',
        required: true,
        width: '6',
        disabled: true,
      },
      {
        name: 'antiguedad',
        label: this.empresaText['antiguedad'],
        type: 'number',
        required: true,
        width: '6',
        disabled: true,
      },
      {
        name: 'formaJuridica',
        label: this.empresaText['formaJuridica'],
        type: 'text',
        required: true,
        width: '6',
        disabled: true,
      },
      {
        name: 'tecnologias',
        label: this.empresaText['tecnologias'],
        type: 'text',
        required: true,
        width: '6',
        disabled: true,
      }
    ];

    this.formPaso2 = this.fb.group({
      tamanoEmpresa: [''],
      empleados: [''],
      ciiu: [''],
      antiguedad: [''],
      formaJuridica: [''],
      tecnologias: ['']
    });
  }

  // VALIDACIONES GENERALES
  validarFormularioPaso1(form: FormGroup) {
    if (form) {
      this.formPaso1 = form;
      const pass = this.formPaso1.get('password')?.value;
      const confirm = this.formPaso1.get('repeatPassword')?.value;
      this.isEqualsPassword = pass == confirm;
    }

  }

  formValidoUno(): boolean {
    return this.formPaso1.valid && this.isEqualsPassword
  }

  onChangePaso1(event: { controlName?: string; form: FormGroup }): void {

  }

  validarFormularioPaso2(form: FormGroup) {
    this.formPaso2 = form;
  }

  onChangePaso2(event: { controlName?: string; form: FormGroup }): void {

  }

  // PASAR AL SIGUIENTE PASO
  async continuarPaso2() {
    const pass = this.formPaso1.get('password')?.value;
    const repeat = this.formPaso1.get('repeatPassword')?.value;

    if (this.formPaso1.invalid) {
      this.formPaso1.markAllAsTouched();
      return;
    }

    if (pass !== repeat) {

      this.alertaModalService.error(this.empresaText['match-password'])
      return;
    }
    const json = {
      // username: this.formPaso1.get('userName')?.value,
      contrasena: pass
    }
    const data = this.decodeJwt(this.token)


    this.empresaService.saveUsuario(data.idSolicitud, json).subscribe({
      next: (resp) => {
        // OK → avanzar
        this.pasoActual = 2;
        this.alertaModalService.confirmacion(this.empresaText['continuar-proceso'],
          '',
          () => {
            this.guardarFormulario();
          }, () => {
          })
      },
      error: (err) => {
        this.alertaModalService.error(this.empresaText['error-guardar-usuario']);
      }
    })
  }

  decodeJwt(token: string): any {
    const payload = token.split('.')[1];
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = atob(base64);
    return JSON.parse(decoded);
  }


  // GUARDAR FORMULARIO FINAL
  guardarFormulario() {
    this.alertaModalService.exito(this.empresaText['titulo-registro-exitoso'],
      this.empresaText['registro-exitoso']
    ).then(() => {
      this.router.navigateByUrl('/loginAdmin', {
        state: { loginEmpresa: true },
      });
    })
  }

}
